import type { JSX } from "react";
import { Trans } from "react-i18next";
import type { BudgetCalculatorResultDTO } from "../../state";
import { useI18n } from "../../i18n";
import { Hint } from "../Hint";
import styles from "./BudgetCalculatorResult.module.css";

type BudgetCalculatorResultProps = {
  result: BudgetCalculatorResultDTO;
};

const BudgetCalculatorResult = ({ result }: BudgetCalculatorResultProps): JSX.Element => {
  const { t, formatNumber } = useI18n();

  return (
    <div className={styles.result} aria-live="polite">
      <div className={styles.maxBikePrice}>
        <span className={styles.maxBikePriceLabel}>
          <Trans i18nKey="budgetCalculator.result.maxBikePrice" />
        </span>
        <span className={styles.maxBikePriceValue}>{formatNumber(result.maxBikePrice, { digits: 0 })} &euro;</span>
      </div>

      {result.serviceRate > 0 && (
        <div className={styles.detailRow}>
          <span>{t("budgetCalculator.result.serviceRate")}</span>
          <span className={styles.detailValue}>{formatNumber(result.serviceRate, { digits: 2 })} &euro;/mtl.</span>
        </div>
      )}

      {result.isMinimumInsuranceRate && (
        <Hint variant="default">{t("budgetCalculator.result.minimumInsuranceNote")}</Hint>
      )}

      {result.isGrantCapped && <Hint variant="default">{t("budgetCalculator.result.grantCappedNote")}</Hint>}
    </div>
  );
};

export { BudgetCalculatorResult };
